import { TextField, InputAdornment, Tooltip } from '@mui/material';
import Search from '@mui/icons-material/Search';
import { useFlags } from 'launchdarkly-react-client-sdk';

export type Props = {
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
    dataTestId?: string;
    variant?: 'standard' | 'outlined' | 'filled';
    tooltipText?: string;
};

const SearchField = ({
    placeholder = 'Search...',
    value,
    onChange,
    dataTestId,
    variant = 'standard',
    tooltipText,
}: Props) => {
    const { searchFlag: hasSearchFlag } = useFlags();

    return (
        <>
            {hasSearchFlag && (
                <Tooltip title={tooltipText} placement="bottom" arrow>
                    <TextField
                        variant={variant}
                        placeholder={placeholder}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            minWidth: 300,
                            maxWidth: 400,
                            width: '100%',
                            flexShrink: 1,
                            marginRight: 2,
                        }}
                        data-testid={dataTestId}
                    />
                </Tooltip>
            )}
        </>
    );
};

export default SearchField;
